import { Component, OnInit } from "@angular/core";
import { DataServiceService } from "../data-service.service";

@Component({
  selector: "app-creditinfo",
  templateUrl: "./creditinfo.component.html",
  styleUrls: ["./creditinfo.component.scss"],
})
export class CreditinfoComponent implements OnInit {
  creditInfo: CreditInfo;
  isLoading: boolean = true;
  constructor(private dataService: DataServiceService) {}

  ngOnInit(): void {
    this.getCreditInfo().then((data) => {
      this.isLoading = false;
    });
  }

  async getCreditInfo() {
    this.creditInfo = await this.dataService.getCreditInfo();
  }
}
